import $ from "jquery";

const TAG_ATTR = "data-lazy-image-tag";

const nextTagId = (function () {
  let id = 0;
  return function () {
    return "tag" + id++;
  };
})();

// we add an attribute to elements that we can use to look them up later. we used to just hold onto a reference
// to the DOM element, but this is not compatible with the CarouselImageSwapper which pulls out and clones DOM
// elements.
function tagElement(element) {
  const tagId = nextTagId();
  element.attr(TAG_ATTR, tagId);
  return tagId;
}

class ProductImage {
  constructor(container, productElement, imageElement, productIndex, imageIndex) {
    this.container = container;
    this.productElementTag = tagElement(productElement);
    this.imageElementTag = tagElement(imageElement);
    this.productIndex = productIndex;
    this.imageIndex = imageIndex;
    this.loaded = false;
  }

  _getProductElement() {
    return this._getTaggedElement(this.productElementTag);
  }

  _getImageElement() {
    return this._getTaggedElement(this.imageElementTag);
  }

  _getTaggedElement(tagId) {
    return this.container.find("[" + TAG_ATTR + "=" + tagId + "]");
  }

  // lower score = image should be shown sooner
  score() {
    return (
      (this.productIsActive() ? 0 : 1000) /* product user is actively interacting with has highest priority */ +
      this.imageIndex * 100 /* then prioritise images that appear sooner in the slider/cycle */ +
      (this.productIsVisible() ? 0 : 10) /* priorities products in the view port next */ +
      this.productIndex
    );
    /* then prioritise products closer to top of the page */
  }

  // whether product is visible on screen, even if this particular image isn't
  productIsVisible() {
    return this._getProductElement().is(":visible");
  }

  // whether product is being interacted with right now
  productIsActive() {
    return this._getProductElement().data("had-interaction") == "yes";
  }

  load(loadedCallback) {
    const srcset = this._getImageElement().attr("data-original-set");
    const src = this._getImageElement().attr("data-original");
    this._getImageElement().on("load", function () {
      loadedCallback && loadedCallback();
      loadedCallback = null;
    });
    this._getImageElement().attr("srcset", srcset);
    this._getImageElement().attr("src", src);
    this.loaded = true;

    // if it hasn't load after a while, continue as if it had, in case it's a failure in detecting that it has
    // loaded. if that's not the case, we'll just end up trying to fetch several images at once, which is no big
    // deal.
    setTimeout(function () {
      loadedCallback && loadedCallback();
      loadedCallback = null;
    }, 500);
  }
}

const LAZY_IMAGE_SELECTOR = ".js-lazy-image";
export class LazyProductImageLoader {
  constructor(container, productSelector) {
    this.productSelector = productSelector;

    this.container = container;
    this._buildImageList();
  }

  _buildImageList() {
    const container = this.container;
    const productImages = (this.productImages = []);
    let productIndex = 0;
    this.container.find(this.productSelector).each(function () {
      const productElement = $(this);
      let imageIndex = 0;
      productElement.find(LAZY_IMAGE_SELECTOR).each(function () {
        const imageElement = $(this);
        const productImage = new ProductImage(container, productElement, imageElement, productIndex, imageIndex);
        productImages.push(productImage);
        imageIndex += 1;
      });
      productIndex += 1;
    });
  }

  nextImageToLoad() {
    let lowestScore;
    let foundProductImage = null;
    this.productImages.forEach(function (productImage) {
      if (!productImage.loaded) {
        const productImageScore = productImage.score();
        if (!foundProductImage || lowestScore > productImageScore) {
          lowestScore = productImageScore;
          foundProductImage = productImage;
        }
      }
    });
    return foundProductImage;
  }

  start() {
    this._tick(true);
  }

  _tick(shouldContinue) {
    if (shouldContinue) {
      this._loadNextImage(this._tick.bind(this));
    }
  }

  _loadNextImage(callback) {
    const productImage = this.nextImageToLoad();
    if (productImage) {
      productImage.load(function () {
        callback(true);
      });
    } else {
      callback(false);
    }
  }
}
